import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["orderedListData", "gridModifier", "children", "entity", "banner", "omitWrappers", "propsToDisplay", "paginationType", "parent", "hasBanner", "gtmData", "itemsToDisplay"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import CardsRenderWrapper from './CardsRenderWrapper';
import { BANNER } from '../../constants';
import Wrapper from '../../../Wrapper';
import { splitChildren, appendImages } from '../../../../helpers';
import { getPropsToDisplayModifiers } from '../../../../utils';
import ListPagination from '../Pagination';
import { LOAD_MORE } from '../../../../constants';
import { useGetImages } from '../../../../hooks';
const CardsRender = _ref => {
  let {
      orderedListData,
      gridModifier,
      children,
      entity,
      banner,
      omitWrappers,
      propsToDisplay,
      paginationType,
      parent,
      hasBanner,
      gtmData,
      itemsToDisplay
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    name
  } = props;
  const dataForGtm = gtmData || orderedListData;
  const {
    regularChildren,
    gtmChildren
  } = splitChildren(children, dataForGtm, entity, {
    name
  });
  const bannerProps = banner ? _objectSpread(_objectSpread({
    parent,
    hasBanner,
    entity,
    propsToDisplay
  }, banner), {}, {
    type: BANNER
  }) : null;
  const propsToDisplayModifiers = getPropsToDisplayModifiers(propsToDisplay);
  const imageIds = itemsToDisplay.map(({
    imageId
  }) => imageId).filter(Boolean);
  const {
    data: imagesData,
    loading: imagesLoading
  } = useGetImages(imageIds, true);
  if (imagesLoading) return '';
  const updatedListWithImages = appendImages(imagesData, orderedListData, itemsToDisplay);
  const WrapperToUse = omitWrappers ? Fragment : Wrapper;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(WrapperToUse, {
    className: "list list--compact"
  }, /*#__PURE__*/React.createElement(CardsRenderWrapper, _extends({
    orderedListData: updatedListWithImages,
    listProps: props,
    bannerProps: bannerProps,
    cardChildren: regularChildren,
    gtmChildren: gtmChildren,
    omitWrappers: omitWrappers,
    propsToDisplay: propsToDisplay,
    propsToDisplayModifiers: propsToDisplayModifiers,
    gridModifier: gridModifier,
    entity: entity,
    parent: parent
  }, props))), paginationType === LOAD_MORE && /*#__PURE__*/React.createElement(ListPagination, _extends({
    paginationType: paginationType,
    parent: parent
  }, props)));
};
CardsRender.propTypes = {
  name: PropTypes.string.isRequired,
  parent: PropTypes.object.isRequired,
  orderedListData: PropTypes.array.isRequired,
  propsToDisplay: PropTypes.array.isRequired,
  paginationType: PropTypes.string.isRequired,
  hasBanner: PropTypes.bool,
  banner: PropTypes.object,
  omitWrappers: PropTypes.bool,
  gridModifier: PropTypes.string,
  entity: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  gtmData: PropTypes.array,
  itemsToDisplay: PropTypes.array
};
CardsRender.defaultProps = {
  gridModifier: '',
  children: null,
  hasBanner: false,
  banner: null,
  omitWrappers: false,
  gtmData: null,
  itemsToDisplay: []
};
export default CardsRender;
//# sourceMappingURL=CardsRender.js.map